import React, { useEffect, useRef, useState } from "react";
import ReactQuill, { Quill } from "react-quill"; // Import Quill from react-quill
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";
import quill from "quill";

window.Quill = quill;

Quill.register("modules/imageResize", ImageResize);

const Block = Quill.import("blots/block");

class CustomBackground extends Block {
  static create(value) {
    const node = super.create();
    node.style.backgroundColor = value;
    return node;
  }
 
  static formats(node) {
    return node.style.backgroundColor;
  }
 
  format(name, value) {
    if (name === "background") {
      this.domNode.style.backgroundColor = value;
    } else {
      super.format(name, value);
    }
  }
}
CustomBackground.blotName = "background";
CustomBackground.tagName = "DIV";
Quill.register(CustomBackground);



const Editor = ({
  slideId,
  placeholder,
  data,
  contentId,
  isSorted,
  setIsDataSaved,
  setCurrentSlideData,
}) => {
  const [editorContent, setEditorContent] = useState("");

  useEffect(() => {
    if (data) {
      setEditorContent(data);
    } else {
      setEditorContent("");
    }
  }, []);

  useEffect(() => {
    setCurrentSlideData((currentSlide) => {
      const newContent = currentSlide.content.map((contentObject) => {
        if (contentObject.id === contentId) {
          return {
            id: contentObject.id,
            type: contentObject.type,
            data: editorContent,
          };
        }
        return {
          ...contentObject,
        };
      });
      return { ...currentSlide, content: newContent };
    });
  }, [editorContent]);

  const handleChange = (html) => {
    setIsDataSaved(false);
    setEditorContent(html);
  };
  // { font: [] } [{ size: [] }]
  const modules = {
    toolbar: [
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline"],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" },
      ],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      [{ color: [] }, { background: [] }],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
    imageResize: {
      parchment: Quill.import("parchment"),
      modules: ["Resize", "DisplaySize"],
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "align",
    "color",
    "background"
  ];

  return (
    <div className="border border-1 border-gray-300 rounded-lg p-3  overflow-y-auto">
      <ReactQuill
        onChange={handleChange}
        value={editorContent}
        modules={modules}
        formats={formats}
        bounds="#root"
        placeholder={"Write something"}
      />
    </div>
  );
};

export default Editor;
